<template>
  <div class="card-page-container mdl-shadow--2dp">
    <div class="mdl-card fill">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{'admin.languages.label.title' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--3-col">
            <strong>{{'admin.languages.name.label' | label }}</strong>
          </div>
          <div class="mdl-cell mdl-cell--3-col">
            <strong>{{'admin.languages.code.label' | label }}</strong>
          </div>
          <div class="mdl-cell mdl-cell--3-col">
            <strong>{{'admin.languages.enabled.label' | label }}</strong>
          </div>
         <div class="mdl-cell mdl-cell--3-col">
          </div>
        </div>
        <div class="mdl-grid" v-for="lang in langs">
          <div class="mdl-cell mdl-cell--3-col">{{lang.label | label}}</div>
          <div class="mdl-cell mdl-cell--3-col">{{lang.code}}</div>
          <div class="mdl-cell mdl-cell--3-col">
            <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="{{lang.code}}-enabled">
            <input type="checkbox" id="{{lang.code}}-enabled" class="mdl-checkbox__input"
              v-model="lang.isActive" v-on:click="update(lang)">
            </label>
          </div>
         <div class="mdl-cell mdl-cell--3-col">
            <input type="number" id="{{lang.code}}-ordinalNo" class="mdl-checkbox__input"
              v-model="lang.ordinalNo">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var api = require('api')
module.exports = {
  ready: function () {
    api.Lang.get()
    .then(this.load)
    .catch(this.onError)
  },
  methods: {
    load: function (resp) {
      this.langs = resp.data
    },
    update: function (lang) {
      lang.isActive = !lang.isActive
      api.Lang.update({
        code: lang.code
      }, lang)
      .then(this.onSuccess)
      .catch(this.onError)
    },
    onSuccess: function () {
      this.$dispatch('show-success', 'admin.languages.update.success')
    },
    onError: function (err) {
      this.$dispatch('show-error', err)
    }
  },
  data: function () {
    return {
      langs: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// Languages.vue?54b56165